import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=6eb61e78&"
import script from "./assignment.vue?vue&type=script&lang=js&"
export * from "./assignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assignment.vue"
export default component.exports